import React from 'react';
import BaseComponent from 'components/BaseComponent';
import { MaterialComponent} from '@/routes/Material/Util/index';
import 'react-contexify/dist/ReactContexify.min.css';
import './style/picture.less';

export default class PictureInfo extends BaseComponent {
	constructor() {
		super();
		this.state = {
			tempRows: [], // 临时存放 所有选中的数据,可多个
			tempKeys: [], // 临时存放 当前选中的keys(id)
			checkRows: [], // 点击确认后 真正使用的值
			checkKeys: [], //点击确认后 真正使用的keys(id)
			visible: false,
			type: '0',
			searchType : 3, // 素材切换查询，清空上次素材缓存
		};
	}

	componentWillReceiveProps(nextProps) {
        const { type } = nextProps;
        this.setState({
            type,
		});
    }

	/** 图片预览: 隐藏图片预览窗口 */
	hidePicModelHandler = (e) => {
		if (e) {
			e.stopPropagation();
		}
		this.setState({
			showPicVisible: false,
			senseArr: [ 200, 200 ]
		});
	};
	/** 查询参数 */
	getPayload = (values, pageNum, pageSize) => {
		let { name = '', pid = '', folderId = '' } = values;
		if (pid === '') {
			pid = this.state.folderId;
			if (pid === '1') {
				pid = '-1';
			}
		}
		if (folderId === '') {
			folderId = this.state.folderId;
		}
		let payload = {
			type: this.state.type,
			currentPage: pageNum,
			rowSize: pageSize,
			name: name,
			pid: pid,
			folderIds: folderId
		};
		return payload;
	};
	/** 查询素材调用 */
	// initSearch = (values, pageNum, pageSize) => {
	// 	let payload = this.getPayload(values, pageNum, pageSize);
	// 	this.props.dispatch({
	// 		type: 'picture/qryPictureList',
	// 		payload
	// 	});
	// };
	onMaterialChecked = (e, ele, type, rows, keys) => {
		if (!ele) {
			return;
		}
		let rowsArr = [];
		let keysArr = [];
		if (e.ctrlKey && type === '0') {
			// 单击 + ctrl键
			rowsArr = this.state.tempRows;
			keysArr = this.state.tempKeys;
			// 查看当是否被选中
			let rowsFindIndex = rowsArr.findIndex((val) => val.id === ele.id);
			// 选中的元素
			if (rowsFindIndex !== -1) {
				rowsArr.splice(rowsFindIndex, 1);
				keysArr.splice(rowsFindIndex, 1);
			} else {
				rowsArr = [ ...rowsArr, ele ];
				keysArr = [ ...keysArr, ele.id ];
			}
		} else {
			// 单击 重新渲染
			rowsArr = [ ele ];
			keysArr = [ ele.id ];
			if (type === '1') {
				// 列表模式
				rowsArr = rows;
				keysArr = keys;
			}
		}
		this.setState({
			tempRows: rowsArr,
			tempKeys: keysArr
		});
	};

	onClearChecked = () => {
		this.setState({
			tempRows: [],
			tempKeys: []
		});
	};

	onOk = () => {
		let rows = this.state.tempRows;
		let keys = this.state.tempKeys;
		this.setState({
			checkRows: rows,
			checkKeys: keys
		});
	};

	onCancel = () => {
		this.setState({
			visible: false
		});
	};
	render() {
		let { type } = this.state;
		const picProps = {
			title: '图片',
			visible: this.state.visible,
			height: 580,
			type: type,
			defaultShow: '0',
			isShowText: true,
			isUpload: true,
			onOk: this.onOk, // 对选中的值进行操作
			onCancel: this.onCancel, // 关闭模态窗口
			checkRows: this.state.tempRows, // 选中的值
			checkKeys: this.state.tempKeys, // 选中的key(存放id)
			onMaterialChecked: this.onMaterialChecked, // 选中图片
			onClearChecked: this.onClearChecked, // 清除选中数据
			searchType : this.state.searchType,
		};
		return <MaterialComponent {...picProps} className="pictureInfo-content" />;
	}
}



// WEBPACK FOOTER //
// ./src/components/Playlist/PictureInfo.js